import axios from 'axios'

// Legacy order calls the portal cancels once sfp-supplier-portal-cutover reads true.
export const CUTOVER_SWITCHED = 'Sfp.errors.switched'

export const LEGACY_ORDER_CALLS = ['supply-orders/', 'generate-label/', 'download/']

export const isLegacyOrderCall = url => typeof url === 'string' && LEGACY_ORDER_CALLS.some(prefix => url.startsWith(prefix))

// errorService's shape, so the legacy screens show errorText as they do for any failure.
export const switchedResponse = () => ({
  status: null,
  level: false,
  headers: null,
  data: null,
  errorText: CUTOVER_SWITCHED,
  switched: true
})

// refresh asks Flipt for the flag; while it reads false the call goes out as it came.
export const guardLegacyOrderCall = async (config, refresh) => {
  if (!isLegacyOrderCall(config.url)) return config
  if (await refresh()) throw new axios.Cancel(CUTOVER_SWITCHED)
  return config
}

export const legacyError = (error, append) => (axios.isCancel(error) ? switchedResponse() : append(error.response))



// WEBPACK FOOTER //
// ./src/sfp/cutover.js